var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _circle, _path8, _path9, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0061 4.39111C12.8045 4.40062 14.0191 5.42329 12.4908 9.43796",
    stroke: "#6DADFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6375 11.9188C10.704 11.1204 11.1792 9.78027 13.0326 9.78027C13.6884 9.78027 14.9144 10.5501 14.9144 11.9188C14.9144 12.5175 14.4012 13.7436 13.2036 13.9432C12.1772 13.9432 11.6126 13.6296 11.1792 13.0593",
    stroke: "#6DADFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.8616H6.90224C7.42498 11.8616 8.69857 11.6792 9.611 10.9492",
    stroke: "#6DADFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37073 13.0304C1.71289 13.4201 2.65382 14.1254 3.6803 13.8288C4.06998 13.7813 4.92918 13.384 5.24853 12.175",
    stroke: "#6DADFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95715 8.15486L7.01621 11.4909H1.22803C1.36489 8.38866 3.88926 7.36599 5.13434 7.24243H7.27283C7.97996 7.28805 8.02368 7.86972 7.95715 8.15486Z",
    fill: "#6DADFB",
    stroke: "#6DADFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0896 6.18733C12.9984 4.86431 12.3102 4.66662 11.9776 4.73315L10.78 8.89609C10.3923 9.89975 10.6185 10.778 10.78 11.0916C10.9169 10.3389 11.7305 9.90355 12.1202 9.78C12.7589 9.02725 13.0326 7.07124 13.0896 6.18733Z",
    fill: "#6DADFB",
    stroke: "#6DADFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.723 11.9473H14.886",
    stroke: "#6DADFB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.09564,
    cy: 11.9469,
    rx: 1.86762,
    ry: 1.82485,
    fill: "#768EAB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.7901,
    cy: 12.1752,
    rx: 1.86762,
    ry: 1.82485,
    fill: "#768EAB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6667,
    cy: 12.2501,
    r: 0.583333,
    fill: "#536E95"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7739 3.50711V0.940918C12.6562 0.940918 12.3292 1.70127 12.2912 2.13847C12.1772 3.18776 13.2227 3.52612 13.7739 3.50711Z",
    fill: "#E1EDFC",
    stroke: "#6DADFB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2953 2.16699H12.4053",
    stroke: "#6DADFB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.59888,
    width: 7.78411,
    height: 7.86965,
    rx: 3,
    fill: "#F46767"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 1.75,
    width: 5.83333,
    height: 1.16667,
    rx: 0.583333,
    fill: "#CC4545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.dd4b8324b4513b939e238388db32572a.svg";
export { ForwardRef as ReactComponent };